import {FaTimes as CancelIcon} from 'react-icons/fa';
import { ReactComponent as World } from '../../../../svg/world.svg';
import styled from '@emotion/styled';
import {ReactComponent as ThreeDots} from '../../../../svg/threeVerticalDots.svg'

interface ModalProps{
    header?: string;
    content?: React.ReactNode;
    card?: React.ReactNode;
    cancel: (parmeter: boolean) => void;
    data?: any;
    open?: boolean;
    showrightIcon?: boolean;
    maxWidth?: string;
    worldIcon?:React.ReactNode;
}

const Modal = ({header,worldIcon, content, cancel, data, open = false, maxWidth, showrightIcon= true, card}: ModalProps) => {
  
    return (
    <>
        {
            open &&
            <SuperContainer >
                <Container width={maxWidth}>
                    <Cancel onClick={()=>cancel(false)}><CancelIcon /></Cancel>
                    <Header>
                        <div>
                            <div className='worldWrapper'>
                                {worldIcon}
                            </div>
                            <span>
                                {header}
                            </span>

                        </div >
                        <div className='iconWrapper'>
                            {
                                showrightIcon &&  <ThreeDots style={{cursor: 'pointer'}}/>
                            }
                            <div className='cardWrapper'>
                                {card}
                            </div> 
                        </div>                     
                    </Header>
                    {
                        content && 
                        <div >
                            {content}
                        </div>
                    }
                </Container>
                <BackDrop onClick={()=>cancel(false)}/>
            </SuperContainer>
        }   
    </>
    )
}

export default Modal;

interface ContainerProps {
    width?: string;
}

const SuperContainer = styled('div')`
    display: flex;
    justify-content: center;
    width: 100%;
    height:100%;
    position: absolute;
    top:0;
    left:0;
    background-color: rgba(78, 83, 79, 0.5);
    z-index: 100;
    overflow: auto;
    padding-block-end: 50px;

`

const BackDrop = styled('div')`
    width: 100%;
    height:100%;
    position: fixed;

`
const Container = styled('div')<ContainerProps>`
    min-width: auto;
    width: ${(props) => (props.width)};
    display: flex;
    flex-direction: column;
    background-color: var(--white-color);
    position: relative;
    z-index:1;
    top:50px;
    margin-block-end: 50px; 
    border-radius: 5px 5px 5px 5px;
    height: fit-content;
`

const Cancel = styled('div')`
    display:flex;
    width:35px;
    height:35px;
    border-radius: 50%;
    position:absolute;
    right:-40px;
    top:0;
    background-color: rgba(255,255,255,0.3);
    color:var(--white-color);
    justify-content: center;
    align-items: center;
    font-size: 20px;
    cursor: pointer;
`
const Header = styled('div')`
    background: #20BB70;
    border-radius: 5px 5px 0px 0px;
    padding: 36px 40px 36px 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > div {
        display: flex;
        align-items: center;
    }

    & .worldWrapper {
        background: #199056;
        border-radius: 6.92308px;
        width: 72px;
        height: 72px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-inline-end: 20px;
    }

    & span {
        font-weight: 600;
        font-size: 20px;
        line-height: 38px;
        color: #FFFFFF;
    }

    & .iconWrapper{
        width: 40px;
        position: relative;
        padding-bottom: 10px;
    }

    &   .iconWrapper:hover > .cardWrapper{
            display: flex;
            flex-direction: column;
        }

    &  .cardWrapper{
        padding-block: 13px;
        width: 167px;
        border: 2px solid black;
        position: absolute;
        display: none;
        top: 30px;
        right: 10px;
        background: #FFFFFF;
        border: 1px solid #F1F1F1;
        box-shadow: 0px 2px 4px rgba(196, 196, 196, 0.25);
        border-radius: 4px;
    }
`



